(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        // On home page, ensure transparency at top on initial load
        if (document.body && document.body.classList.contains('home-page')) {
          const scrollY = window.scrollY || window.pageYOffset || 0;
          if (scrollY <= 10 && !this.header.classList.contains('scrolled-past-header')) {
            if (this.classList.contains('gradient')) {
              this.classList.add('gradient-removed-for-transparency');
              this.classList.remove('gradient');
            }
            this.style.setProperty('backdrop-filter', 'none', 'important');
            this.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
            this.style.setProperty('background', 'transparent', 'important');
            this.style.setProperty('background-color', 'transparent', 'important');
          }
        }

        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
          // After bounds are set, ensure transparency is correct on home page
          if (document.body.classList.contains('home-page')) {
            const scrollY = window.scrollY || window.pageYOffset || 0;
            if (scrollY <= 10) {
              // Force transparency on initial load
              if (this.classList.contains('gradient')) {
                this.classList.add('gradient-removed-for-transparency');
                this.classList.remove('gradient');
              }
              this.style.setProperty('backdrop-filter', 'none', 'important');
              this.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
              this.style.setProperty('background', 'transparent', 'important');
              this.style.setProperty('background-color', 'transparent', 'important');
            }
          }
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        
        // Trigger our transparency update after StickyHeader updates the class
        if (document.body.classList.contains('home-page')) {
          // Use requestAnimationFrame to ensure our code runs after class changes
          requestAnimationFrame(() => {
            const event = new CustomEvent('stickyHeaderScrolled', { 
              detail: { scrollTop, hasScrolledClass: this.header.classList.contains('scrolled-past-header') }
            });
            window.dispatchEvent(event);
          });
        }
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);

    // Header transparency is now handled in theme.liquid for better performance
    // This minimal code ensures gradient class is managed for non-home pages
    (function() {
      if (!document.body.classList.contains('home-page') && window.location.pathname !== '/' && window.location.pathname !== '/index') {
        const headerWrapper = document.querySelector('sticky-header.header-wrapper') || document.querySelector('.header-wrapper');
        if (headerWrapper && headerWrapper.classList.contains('gradient-removed-for-transparency')) {
          headerWrapper.classList.remove('gradient-removed-for-transparency');
          headerWrapper.classList.add('gradient');
        }
      }
    })();
  
  } catch(e) { console.error(e); }
})();
})();
